import React from "react";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik } from "formik";
import { Grid, Typography, Card } from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import api from "../../../components/services/api";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function EditTransshipment() {
  const [transshipment_name, setTransshipment_name] = useState();
  const [transshipment_no, setTransshipment_no] = useState();
  const [transshipment_status, setTransshipment_status] = useState(0);
  let { id } = useParams();
  const classes = useStyles();

  //fetch Data

  const data_params = { id: id };
  const getData = async () => {
    try {
      const data = await api
        .post("api/transshipment/detail", data_params)
        .then((response) => {
          if (response.data.length !== 0) {
            [].concat(response.data).map((res) => {
              // console.log(res.FreightTermsNo);
              setTransshipment_name(res.TransshipmentName);
              setTransshipment_no(res.TransshipmentNo);
              // console.log(`ft`, res.TransshipmentNo);
              // res.Status.data.map((res) => {
              //   setTransshipment_status(res);
              //   //   console.log(res);
              // });
              setTransshipment_status(res.Status === true ? 1 : 0);

            });
          } else {
            const MySwal = withReactContent(Swal);

            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "ผิดพลาด!",
                "ไม่พบรหัสอ้างอิงดังกล่าว !",
                "error"
              ).then((result) => {
                if (result.isConfirmed) {
                  history.push("/Setting/Transshipment");
                }
              });
            });
            // console.log("Nodata" + response);
          }
          //   console.log(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };
  //api call
  useEffect(() => {
    // GET request using axios inside useEffect React hook
    getData();

    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, []);

  const history = useHistory();
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
        การขนส่ง
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Transshipment
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / Transshipment
            </Typography>
          </Grid>
        </Grid>
        <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
          แก้ไขการขนส่ง
        </h6>
        <Formik
          initialValues={{ transshipment_name: "", transshipment_no: "" }}
          validate={(values) => {
            const errors = {};
            if (!transshipment_name || transshipment_name === "") {
              errors.f_t_name = "Required";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              const data = {
                id: id,
                no: transshipment_no,
                name: transshipment_name,
                status: transshipment_status,
              };

              api
                .post("api/transshipment/update", data)
                .then((respose) => {
                  const MySwal = withReactContent(Swal);

                  MySwal.fire({
                    icon: "success",
                    didOpen: () => {
                      MySwal.clickConfirm();
                    },
                  }).then(() => {
                    return MySwal.fire(
                      "สำเร็จ!",
                      "แก้ไขข้อมูลข้อมูลการขนส่งสำเร็จ !",
                      "success"
                    ).then((result) => {
                      if (result.isConfirmed) {
                        history.push("/Setting/Transshipment");
                      }
                    });
                  });
                  console.log(respose);
                })
                .catch((err) => {
                  console.log(err);
                });

              // alert(JSON.stringify(f_t_no + f_t_name + f_t_status, null, 2));
              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={6} sm={3} md={12}>
                  <TextField
                    name="transshipment_name"
                    label="TRANSSHIPMENT NAME"
                    variant="outlined"
                    placeholder="TRANSSHIPMENT NAME"
                    onChange={(e) => setTransshipment_name(e.target.value)}
                    onBlur={handleBlur}
                    style={{ width: "50%" }}
                    InputLabelProps={{ shrink: true }}
                    value={transshipment_name}
                    required
                    classes={{ root: !values.transshipment_name ? classes.customOutline : null }}
                  />
                  {/* {errors.transshipment_name &&
                    touched.transshipment_name &&
                    errors.transshipment_name} */}
                </Grid>
                <Grid item xs={6} sm={4} md={10} sx={{ display: "flex" }}>
                  <TextField
                    label="TRANSSHIPMENT  NO."
                    InputLabelProps={{ shrink: true }}
                    placeholder="Enter TRANSSHIPMENT  NO."
                    name="transshipment_no"
                    onChange={(e) => setTransshipment_no(e.target.value)}
                    onBlur={handleBlur}
                    style={{
                      width: "40%",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    value={transshipment_no}
                    required
                    classes={{ root: !values.transshipment_no ? classes.customOutline : null }}
                  />
                  {/* {errors.transshipment_no &&
                    touched.transshipment_no &&
                    errors.transshipment_no} */}
                  <FormControl fullWidth>
                    <InputLabel id="select_status-label">Status</InputLabel>
                    <Select
                      name="select_status"
                      id="select_status"
                      value={transshipment_status}
                      label="Status"
                      style={{
                        width: "40%",
                        marginLeft: "10px",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                      onChange={(e) => setTransshipment_status(e.target.value)}
                    >
                      <MenuItem value={1}>Active</MenuItem>
                      <MenuItem value={0}>InActive</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Button
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                onClick={history.goBack}
              >
                back
              </Button>
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                disabled={isSubmitting}
              >
                {isSubmitting && <CircularProgress size={22} />}
                {!isSubmitting && "SAVE"}
              </Button>
            </form>
          )}
        </Formik>
      </Card>
    </div>
  );
}
